/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseBroadcastDetailsResponse } from '../../models/api-response-broadcast-details-response';

export interface GetBroadcastByReference$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
  reference: string;
}

export function getBroadcastByReference(http: HttpClient, rootUrl: string, params: GetBroadcastByReference$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseBroadcastDetailsResponse>> {
  const rb = new RequestBuilder(rootUrl, getBroadcastByReference.PATH, 'get');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.path('reference', params.reference, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseBroadcastDetailsResponse>;
    })
  );
}

getBroadcastByReference.PATH = '/v1/api/ui/broadcast/{reference}';
